<template>
  <section>
    <div class="messages-center-mc-wrapper" :style="{'--messagesCenter-mainColor':messagesCenter.mainColor, '--messagesCenter-bgColor':messagesCenter.bgColor,'--messagesCenter-nameColor':messagesCenter.nameColor,'--messagesCenter-nameBoxColor':messagesCenter.nameBoxColor,'--messagesCenter-boxColor':messagesCenter.boxColor,'--messagesCenter-textColor':messagesCenter.textColor,'--messagesCenter-inputTextColor':messagesCenter.inputTextColor,'--messagesCenter-inputBGColor':messagesCenter.inputBGColor,'--messagesCenter-inputOutlineColor':messagesCenter.inputOutlineColor,'--messagesCenter-messagesCentersOutlineColor':messagesCenter.messagesCentersOutlineColor,
    '--messagesCenter-sendButtonColor':messagesCenter.sendButtonColor,
    '--messagesCenter-sendButtonBGColor':messagesCenter.sendButtonBGColor,
  '--messagesCenter-scrollbarBGColor':messagesCenter.scrollbarBGColor,
  '--messagesCenter-scrollbarHandleColor':messagesCenter.scrollbarHandleColor,
  '--messagesCenter-borderRadius':messagesCenter.borderRadius}">
      <div class="messages-center-mc-box">
        <Spinner style="background:#0000;position:absolute;width:50%;height:100%;top:20px;left:0;z-index:1;" :showSpinner="showSpinner"/>
        <div class="mc-channel-list-container" ref="channelsContainer">
          <div class="mc-title-container" v-html="messagesCenter.header">
            <!-- <ion-icon name="mail-outline" class="messages-mail-icon"></ion-icon> -->
          </div>
          <button class="mc-close-btn" @click.prevent="closeMessagesCenter" v-if="!channelId"><i class="far fa-times-circle"></i></button>
          <ul class="mc-channel-list" >
            <li v-for="(channel,i) in channels" :key="i" class="mc-channel-item">
              <a @click.prevent="openConversation(channel.talk_channel_id)" class="mc-channel-name">
                <ion-icon name="person-circle-outline" class="mc-avatar-icon" v-if="!channel.image"></ion-icon>
                <img class="mc-avatar-image" :src="channel.image" v-if="channel.image"/>
                <div class="mc-name-and-extras">
                  <span>{{ channel.name }}</span>
                  <div class="mc-extra-info" v-if="false">
                    <span>Company -</span>
                    <span>Role - </span>
                    <span>extra</span>
                  </div>
                </div>
                <!-- <button style="margin-left:auto;" @click.stop="removeChannel(channel.talk_channel_id)">X</button> -->
              </a>
              <span class="mc-unread-marker" v-show="channel.new_message > 0">{{ channel.new_message }}</span>
            </li>
          </ul>
        </div>
        <div class="mc-conversation-container" ref="conversationContainer">
          <!-- <button class="mc-close-btn" @click.prevent="closeMessagesCenter"><i class="far fa-times-circle"></i></button> -->
          <div class="mc-conversation-title-container">
            <button @click.prevent="backList" class="mc-back-link"><ion-icon name="chevron-back-outline"></ion-icon></button>
            <img class="mc-conversation-avatar-image" :src="channelAvatar" v-if="channelAvatar"/>
            <ion-icon name="person-circle-outline" class="mc-conversation-avatar-icon" v-if="!channelAvatar"></ion-icon>
            <span class="mc-conversation-title-display">{{ channelName }}</span>
            <i class="fas fa-video mc-send-message" title="Chamada de vídeo" @click="sendBlitzarMeetingInvite(channelId)"></i>
            <!-- <i class="far fa-times-circle" @click.prevent="closeMessagesCenter"></i> -->
          </div>
          <div class="mc-messages-container" ref="messagesContainer">
            <div class="mc-message-item" :class="{'to-the-left':userId!=message.from_user_id,'to-the-right':userId==message.from_user_id}" v-for="message in messages" :key="message.message_id">
              <p class="mc-message-content" :class="{'not-user':userId!=message.from_user_id,'is-user':userId==message.from_user_id}" :style="{cursor:message.tags==='blitzar-meeting-invite'?'pointer':'auto'}" @click="messageClickeHandler(message)">
                <i class="fas fa-video" style="font-size:0.9rem" v-if="message.tags==='blitzar-meeting-invite'"></i>
                {{ message.text }}
              </p>
              <div class="mc-message-time" :class="{'time-to-the-left':userId!=message.from_user_id,'time-to-the-right':userId==message.from_user_id}">
                {{ dateFormatHandler(message.created_at) }}
              <i class="fas fa-window-close" style="font-size:0.8rem" v-if="userId==message.from_user_id" @click.prevent="editMessage(message)"></i>
              </div>
            </div>
          </div>
          <div class="mc-input-and-button">
            <input ref="messagesCenterInput" id="messagesCenterInput" class="mc-message-input" v-model="messageText" @keypress.enter="sendMessage">
            <button class="mc-send-message" @click="sendMessage"><ion-icon name="arrow-redo-outline" v-if="messagesCenter.enableSendButton"></ion-icon></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import Spinner from '@/components/ui/Spinner.vue';
import api from '@/services/api';
import * as dayjs from 'dayjs';

//import { API } from 'aws-amplify';
import { createChatBlitzar } from '@/graphql/mutations';
import { OnCreateChatBlitzarByUserId } from '@/graphql/subscriptions';

export default {
  name: 'MessagesCenter',

  components: {
    Header,
    Footer,
    Spinner,
  },

  props: {
    channelIdProp: String,
  },

  data() {
    return {
      channelId: '',
      userId: '',
      messagesCenter: {},
      channels: [],
      messages: [],
      currentChannel: {
        name: '',
      },
      messageText: '',
      dayjs: null,
      lastMessageId: '',
      loadMessagesInterval: null,
      loadChannelsInterval: null,
      showSpinner: false,
      subscriptionGraphQL: null,
      user_id_dest: null,
      audio: null,
      accessConfig: null,
    };
  },

  watch: {
    $route() {
      this.getMessages();
    },
    channelIdProp: function (newVal, oldVal) {
      // console.log('channelId prop changed in MessagesCenter: ' + newVal);
      this.$nextTick(() => {
        // this.channelId = newVal;
        this.$nextTick(_ => {
          this.getChannels();
          this.openConversation(newVal);
        });
      });
    },
  },

  computed: {
    channelName() {
      let name = '';
      if (this.channelId) {
        this.channels.forEach(channel => {
          //console.log('Channel=',channel);
          if (channel.talk_channel_id == this.channelId) name = channel.name;
        });
      }
      return name;
    },
    channelAvatar() {
      let avatar = null;
      if (this.channelId) {
        this.channels.forEach(channel => {
          if (channel.talk_channel_id == this.channelId) avatar = channel.image;
        });
      }
      return avatar;
    },
  },

  methods: {
    getUserIdDest() {
      let user_id_dest = '';
      if (this.channelId) {
        this.channels.forEach(channel => {
          //console.log('Channel=',channel);
          if (channel.talk_channel_id == this.channelId) user_id_dest = channel.user_id_dest;
        });
      }
      return user_id_dest;
    },
    receiveMessage(incoming) {
      const msg = JSON.parse(incoming.data);
      // console.log('Message Received', msg);
      if (msg.type == 'message-center') {
        if (this.channelId == msg.channel_id) {
          // console.log('update Channel', msg);
          this.getLatestMessages();
        } else {
          // console.log('Play Audio', msg);
          this.audio.play();
        }
      }
    },
    subscribeGraphQl() {
      /*
      //console.log('GraphQL subscribe');
      this.subscriptionGraphQL = API.graphql({
        query: OnCreateChatBlitzarByUserId,
        variables: {
          user_id: this.$store.state.user.id,
        },
        authToken: this.$store.state.user.tokenJWT,
      }).subscribe({
        next: (eventData) => {
          let msg = eventData.value.data.onCreateChatBlitzarByUserId.message;
          //console.log('GraphqlMsg =',msg);
          try {
            const rec = JSON.parse(msg);
            //console.log('GraphqLMsgParse =',rec);
            if (rec.type === 'message-center') {
              //console.log('ToReceive =',msg)
              this.receiveMessage({ data: msg });
            }
          } catch (err) {
            console.error(err);
          }
          return;
        },
      });
      */
    },
    async createChatBlitzar(msg, user_id) {
      /*
      //console.log('Create TODO:', msg);
      const name = 'message-center';
      const message = JSON.stringify(msg);
      //const user_id = user_id;
      const todo = { name, message, user_id };
      await API.graphql({
        query: createChatBlitzar,
        variables: { input: todo },
        authToken: this.$store.state.user.tokenJWT,
      });
      */
    },
    dateFormatHandler(timestamp) {
      // console.log('timestamp: ' + timestamp);
      let messageDate = this.dayjs(timestamp);
      let dateDiff = messageDate.diff(this.dayjs(Date.now()), 'day');
      // console.log('messageDate: ' + dayjs(messageDate).format('DD/MM HH:mm') + ' - dateDiff: ' + dateDiff);
      if (dateDiff < 0) {
        return this.dayjs(timestamp).format('DD/MM - HH:mm');
      } else return this.dayjs(timestamp).format('HH:mm');
    },
    getChannels(isMount) {
      // console.log('getChannels: ' + this.channelId, isMount);
      if (isMount) this.showSpinner = true;
      api
        .get(`event/${this.$store.state.eventId}/talkChannel?limit=10000`)
        .then(response => {
          // console.log('getChannels response: ', { response });

          this.channels = response.data.reverse();
          // this.channels.sort((a, b) => a.name.localeCompare(b.name));
          this.showSpinner = false;
        })
        .catch(err => console.error);
    },
    getMessages(isMount) {
      //console.log('getMessages: ' + this.channelId);

      if (!this.channelId) {
        this.$refs.conversationContainer.classList.remove('active');
        return;
      }
      // console.log('Gonna call api with channelID: ' + this.channelId, isMount);
      if (isMount) this.showSpinner = true;

      api
        .get(`event/${this.$store.state.eventId}/messagesChannel?channel=${this.channelId}`)
        .then(response => {
          this.lastMessageId = response.data[0].talk_messages_id;
          this.messages = response.data.reverse();

          let hasNewMessage;
          this.channels.map(channel => {
            // console.log(JSON.stringify(channel));
            hasNewMessage = channel.new_message > 0 && this.channelId == channel.talk_channel_id;
          });
          this.$nextTick(_ => {
            this.showSpinner = false;
            // console.log(JSON.stringify(hasNewMessage));
            this.$refs.conversationContainer.classList.add('active');
            if (hasNewMessage) {
              this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
            }
          });
        })
        .catch(error => {
          this.showSpinner = false;
          console.error;
        });
    },
    getLatestMessages() {
      if (!this.channelId || !document.activeElement.id.includes('message')) return;
      // console.log('getLatestMessages', document.activeElement);
      api
        .get(`event/${this.$store.state.eventId}/lastMessagesChannel?channel=${this.channelId}`)
        .then(response => {
          if (response && response.data && response.data.length) {
            this.lastMessageId = response.data[0].talk_messages_id;
            this.messages = this.messages.concat(response.data.reverse());
            this.$nextTick(_ => {
              this.$refs.conversationContainer.classList.add('active');
              this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
            });
          }
        })
        .catch(err => console.error);
    },
    sendMessage() {
      const msg = {
        channel_id: this.channelId,
        message: this.messageText,
        type: 'message-center',
      };
      //console.log('Send Message=',msg)
      if (this.accessConfig.graphQl) {
        this.createChatBlitzar(msg, this.getUserIdDest());
      }
      api
        .post(`event/${this.$store.state.eventId}/sendMessageChannel`, {
          channel_id: this.channelId,
          message: this.messageText,
        })
        .then(response => {
          // console.log('message sent');
          let msg = response.data;
          msg.name = this.$store.state.user.name;
          this.messageText = '';
          this.messages.push(msg);
          this.$nextTick(_ => {
            this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
          });
        })
        .catch(err => console.error(err));
    },
    editMessage(message) {
      api
        .put(`event/${this.$store.state.eventId}/editMessageChannel`, {
          channel_id: message.talk_channel_id,
          message_id: message.talk_messages_id,
          message: 'mensagem removida',
          // reactions: messsage.reactions,
        })
        .then(response => {
          // console.log('editMessage', { response });
          this.getMessages();
        })
        .catch(err => console.error);
    },
    removeChannel(id) {
      let payload = {
        data: {
          channel_id: id,
          message_id: id,
        },
      };
      // console.log('removeChannel', payload);
      api
        .delete(`event/${this.$store.state.eventId}/removeMessageChannel`, payload)
        .then(response => {
          console.log('removeChannel response', { response });
        })
        .catch(err => console.error);
    },
    backList() {
      this.$refs.conversationContainer.classList.remove('active');
      this.$refs.channelsContainer.classList.remove('mc-invisible');
      document.getElementById('messagesContainer').focus();
      this.channelId = null;
    },
    openConversation(channelId) {
      // console.log('openConversation channelId', channelId);

      this.showSpinner = true;
      this.channelId = channelId;
      if (!this.channelId) {
        this.$refs.conversationContainer.classList.remove('active');
        this.$refs.channelsContainer.classList.remove('mc-invisible');
        return;
      }
      api
        .get(`event/${this.$store.state.eventId}/messagesChannel?channel=${this.channelId}`)
        .then(response => {
          // console.log('openConversation api get messagesChannel', { response });

          this.lastMessageId = response.data[0].talk_messages_id;
          this.messages = response.data.reverse();
          this.$nextTick(_ => {
            this.$refs.conversationContainer.classList.add('active');
            this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
            this.showSpinner = false;
            // document.getElementById('messagesCenterInput').focus();

            // this.$refs.channelsContainer.classList.add('mc-invisible');

            setTimeout(() => {
              this.$refs.messagesCenterInput.focus();
            }, 1000);
          });
        })
        .catch(err => console.error);
    },
    getUserData(userId) {
      try {
        api
          .get(`event/${this.$store.state.eventId}/user/${userId}`)
          .then(response => {
            // console.log('User= ', response.data);
            if (response.data) {
              // console.log('Response Data =', response.data);
              return 'Cantor';
            }
          })
          .catch(err => console.error(err));
      } catch (error) {
        console.error(error);
      }
    },
    closeMessagesCenter() {
      this.$emit('closeMessagesCenter');
      this.$nextTick(_ => {
        // this.$refs.messagesContainer.style.display = 'none';
      });
    },
    messageClickeHandler(message) {
      if (message.tags === 'blitzar-meeting-invite' && !this.$store.state.user.inMeeting) {
        this.$root.$emit('joinBlitzarMeeting', message.talk_channel_id);
        setTimeout(() => {
          document.activeElement.blur();
        }, 2000);
      }
    },
    sendBlitzarMeetingInvite(channelID) {
      return new Promise((resolve, reject) => {
        api
          .post(`event/${this.$store.state.eventId}/sendMessageChannel`, {
            channel_id: channelID,
            message: `${this.$store.state.user.name} está te convidando para uma vídeo chamada. Clique para entrar.`,
            reactions: 'blitzar-meeting-invite',
          })
          .then(response => {
            // console.log('message sent', { response });
            let msg = response.data;
            msg.name = this.$store.state.user.name;
            this.messageText = '';
            this.messages.push(msg);
            this.$nextTick(_ => {
              this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
              this.$root.$emit('joinBlitzarMeeting', channelID);
              resolve(response);
            });
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
  },

  beforeMount() {
    this.audio = new Audio('https://www.redringtones.com/wp-content/uploads/2019/05/glass-tone.mp3');
    this.dayjs = dayjs;
    this.messagesCenter = this.$store.state.template.message; // admin properties
    this.accessConfig = this.$store.state.template.accessConfig;
    this.userId = this.$store.state.user.id;
    // this.getUserData('f55470c0-56a0-11eb-8241-eb6831fcfaaa');
    this.channelId = this.channelIdProp;
    this.getChannels(true);
    if (this.channelId) {
      // console.log('call api to retrieve channel data');
      this.getMessages(true);
    }
    if (this.accessConfig.graphQl) {
      this.subscribeGraphQl(); //GraphQL Test
    }
  },
  mounted() {
    this.loadMessagesInterval = setInterval(this.getLatestMessages, 5000);
    // this.loadChannelsInterval = setInterval(this.getChannels, 5000);
  },

  beforeDestroy() {
    clearInterval(this.loadMessagesInterval);
    // clearInterval(this.loadChannelsInterval);
    // console.log('GraphQL unsubscribe');
    if (this.subscriptionGraphQL) {
      this.subscriptionGraphQL.unsubscribe();
    }
  },
};
</script>

<style lang="scss">
.messages-center-mc-wrapper {
  position: relative;
  width: 320px;
  height: 370px;
  display: flex;
  flex-direction: column;
  cursor: auto;
}

.messages-center-mc-box {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--messagesCenter-mainColor);
  display: flex;
  flex-grow: 1;
  height: 80%;
  // margin: 100px auto 50px auto;
  overflow: hidden;
  border-radius: var(--messagesCenter-borderRadius);
  @include media("<=phone") {
    border-radius: 0;
  }
}
.mc-channel-list-container {
  position: relative;
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  visibility: visible;
}
.mc-invisible {
  visibility: hidden;
}
.mc-title-container {
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 11px;
  // font-size: 2rem;
  color: var(--messagesCenter-textColor);
  background-color: var(--messagesCenter-mainColor);
  flex-grow: 0;
  display: flex;
  align-items: center;

  .messages-mail-icon {
    color: var(--button-text);
    font-size: 3rem;
  }
}
.mc-close-btn {
  position: absolute;
  right: 6px;
  top: 6px;
  z-index: 1;
  color: var(--messagesCenter-textColor);
  background: none;
  border: none;
  transition: all 100ms ease-in-out;
  filter: brightness(0.6);
  i {
    font-size: 18px;
  }
  &:hover {
    transform: scale(1.2);
    filter: brightness(0.8);
  }
  @include media("<=phone") {
    display: none;
  }
}
.mc-channel-list {
  position: relative;
  list-style: none;
  padding: 0;
  margin-bottom: 6px;
  overflow: auto;
}
.mc-channel-item {
  background-color: transparent;
  position: relative;
  width: 100%;
  border-bottom: 2px solid var(--messagesCenter-mainColor);
}

.mc-channel-name {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px 8px;
  margin: 0 10px;
  font-weight: bold;
  font-size: 16px;
  color: var(--messagesCenter-nameColor);
  background-color: var(--messagesCenter-nameBoxColor);
  border-radius: var(--messagesCenter-borderRadius);
}
.mc-name-and-extras {
  display: flex;
  flex-direction: column;
}
.mc-avatar-image {
  position: relative;
  object-fit: cover;
  object-position: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 6px;
}
.mc-avatar-icon {
  font-size: 34px;
  margin-right: 6px;
}
.mc-conversation-title-container {
  position: relative;
  width: 100%;
  min-height: 38px;
  padding: 10px;
  color: var(--messagesCenter-nameColor);
  display: flex;
  align-items: center;
}
.mc-back-link {
  position: relative;
  // margin-right: auto;
  color: var(--messagesCenter-textColor);
  display: flex;
  align-items: center;
  z-index: 1;
  background: transparent;
  border: none;
  cursor: pointer;
}
.mc-conversation-avatar-image {
  position: relative;
  object-fit: cover;
  object-position: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 6px;
  margin-left: auto;
}
.mc-conversation-avatar-icon {
  position: relative;
  font-size: 30px;
  margin-right: 6px;
  margin-left: auto;
}
.mc-conversation-title-display {
  position: relative;
  font-weight: bold;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  margin-right: auto;
}
.mc-extra-info {
  position: relative;
  font-size: 0.8rem;
  color: var(--messagesCenter-nameColor);
  opacity: 0.7;
}
.mc-conversation-container {
  position: relative;
  background-color: var(--messagesCenter-mainColor);
  flex-grow: 1;
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
}

.mc-unread-marker {
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #202020;
  color: #ececec;
}

.mc-messages-container {
  position: relative;
  background-color: var(--messagesCenter-bgColor);
  // margin: 0 6px;
  padding: 3% 4%;
  flex-grow: 5;
  overflow: auto;
  height: 74%;
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--messagesCenter-scrollbarBGColor);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--messagesCenter-scrollbarHandleColor);
  }
}
.to-the-left {
  align-items: flex-start;
}
.to-the-right {
  align-items: flex-end;
}
.not-user {
  background-color: var(--messagesCenter-boxColor);
}
.is-user {
  background-color: var(--messagesCenter-nameBoxColor);
}
.time-to-the-left {
  justify-content: flex-start;
}
.time-to-the-right {
  justify-content: flex-end;
}
.mc-message-item {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  // align-items: center;
  width: 100%;
  font-size: 1rem;
  margin-bottom: 10px;
  .sender-name {
    position: relative;
    font-weight: bold;
    color: var(--messagesCenter-nameColor);
    &::after {
      position: relative;
      content: "-";
      margin: 0 4px;
    }
  }
  .mc-message-content {
    position: relative;
    color: var(--messagesCenter-nameColor);
    max-width: 80%;
    padding: 2% 3%;
    border-radius: var(--messagesCenter-borderRadius);
    overflow-wrap: break-word;
    -webkit-user-select: text;
    user-select: text;
    cursor: text;
  }
}
.mc-message-time {
  position: relative;
  color: var(--messagesCenter-nameColor);
  opacity: 0.6;
  font-weight: normal;
  font-size: 0.6rem;
  padding: 1%;
  // display: flex;
}
.mc-input-and-button {
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  height: 40px;
  padding: 0 8px;
}
.mc-message-input {
  position: relative;
  width: 100%;
  height: 26px;
  color: var(--messagesCenter-inputTextColor);
  background-color: var(--messagesCenter-inputBGColor);
  outline: none;
  border: 1px solid var(--messagesCenter-inputOutlineColor);
  border-radius: var(--messagesCenter-borderRadius);
  margin-right: 8px;
  padding-left: 4px;
  &:focus {
    outline: none;
  }
}

.mc-send-message {
  cursor: pointer;
  position: relative;
  border-radius: var(--messagesCenter-borderRadius);
  background-color: var(--messagesCenter-sendButtonBGColor);
  text-align: center;
  // padding: 10px;
  color: var(--messagesCenter-sendButtonColor);
  box-shadow: none;
  border: none;

  &:active {
    transform: scale(0.95);
  }
}

.mc-conversation-container {
  transition: transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &.active {
    transform: translate3d(-100%, 0, 0);
  }
}
</style>